var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.204 13.238 3.25 31.567a.4.4 0 0 0 .521.498l18.041-6.777",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.703 25.184c-.02.02-.068.054-.186.065a1.576 1.576 0 0 1-.52-.065c-.453-.119-1.048-.389-1.751-.803-1.401-.826-3.157-2.182-4.928-3.875s-3.205-3.386-4.094-4.748c-.446-.684-.742-1.266-.881-1.713a1.575 1.575 0 0 1-.089-.516c.006-.119.037-.168.057-.189.02-.02.068-.054.186-.065.122-.011.293.005.52.065.452.119 1.048.389 1.75.803 1.402.826 3.158 2.182 4.929 3.875 1.771 1.693 3.205 3.386 4.093 4.748.446.684.743 1.266.882 1.713.07.223.094.394.088.516-.005.119-.036.168-.056.189z",
    stroke: "#333",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64 18.253v0a26.263 26.263 0 0 0 9.23 8.822v0M6.194 22.694v0a17.942 17.942 0 0 0 6.305 6.027v0M4.924 26.603v0a10.572 10.572 0 0 0 3.716 3.551v0M11.99 15.374c3.52-2.148 3.567-5.232 2.241-6.28-1.985-1.567-3.68.992-2.282 1.89 1.798 1.155 5.224-1.811 2.38-5.598M19.56 22.64c1.66-2.736 5.618-3.035 6.91-1.947 2.786 2.345-1.1 4.75-2.094 2.223-.608-1.546 2.07-4.198 6.122-2.116",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.748,
    cy: 14.125,
    r: 1.893,
    transform: "rotate(15.384 25.748 14.125)",
    fill: "#31B59F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.097,
    cy: 16.386,
    r: 1.04,
    transform: "rotate(15.384 18.097 16.386)",
    fill: "#31B59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.571 1.156a.042.042 0 0 1 .073-.02l1.693 1.938c.01.01.023.016.037.015l2.556-.296a.042.042 0 0 1 .041.063l-1.32 2.21a.042.042 0 0 0-.002.038l1.072 2.34a.042.042 0 0 1-.048.059l-2.509-.573a.042.042 0 0 0-.038.01l-1.894 1.742a.042.042 0 0 1-.07-.027l-.231-2.563a.042.042 0 0 0-.021-.033l-2.242-1.263a.042.042 0 0 1 .004-.076l2.366-1.011a.042.042 0 0 0 .025-.03l.508-2.523z",
    fill: "#31B59F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.757 .451)",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.e45c536cf890d7888345fcf24f1fb20b.svg";
export { ForwardRef as ReactComponent };